export default __webpack_public_path__ + "static/media/charity.68b0b43c.svg";